var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"c-users-table-head"},[_c('tr',_vm._l((_vm.columns),function(column){return _c('th',{key:column,staticClass:"c-users-table-head__column"},[_vm._v(" "+_vm._s(_vm.i18n.t(("vUsers.table.headers." + column)))+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }